import { Link } from "react-router-dom";
import './Footer.css';

function Footer() {
  return (
    <div className="footer">
      <p>
        Learn more about <Link to="/">Job-Fax</Link> here.
      </p>
    </div>
  );
}

export default Footer;
